import createDailyRecurrence from './createDailyRecurrence';
import createWeeklyRecurrence from './createWeeklyRecurrence';
import type RecurrenceType from 'owa-service/lib/contract/RecurrenceType';
import type { DisplayDate } from 'owa-datetime';

export default function createRecurrenceFromSelectedDays(
    startDate: DisplayDate,
    selectedDays: string[],
    interval: number,
    endDate: DisplayDate
): RecurrenceType {
    let areAllDaysSelected = selectedDays.length == 7;
    if (!areAllDaysSelected) {
        return createWeeklyRecurrence(selectedDays.join(' '), interval, startDate, endDate);
    } else {
        return createDailyRecurrence(startDate, interval, endDate);
    }
}
